import { render, staticRenderFns } from "./orgUserChoose.vue?vue&type=template&id=60098eb4&scoped=true&"
import script from "./orgUserChoose.vue?vue&type=script&lang=js&"
export * from "./orgUserChoose.vue?vue&type=script&lang=js&"
import style0 from "./orgUserChoose.vue?vue&type=style&index=0&id=60098eb4&prod&lang=less&scoped=true&"
import style1 from "./orgUserChoose.vue?vue&type=style&index=1&id=60098eb4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60098eb4",
  null
  
)

export default component.exports